/**
 * HostEncodeCap (F6, flag av_ios_light_encode) — iPhone/iPad hosts only.
 * With ≥2 guests on stage the host must encode 3 simulcast layers AND decode the
 * guests; WebKit hits a CPU limit → slow-motion video / A-V drift. Cap the camera
 * sender at runtime (720p→540p-equivalent, 24 fps, 800 kbps) and restore when the
 * stage empties. No reconnect, no track restart.
 */
import { useEffect } from "react";
import { useRoomContext } from "@livekit/components-react";
import { Track } from "livekit-client";
import { IS_IOS } from "@/components/live-room/LiveRoomStage";

export default function HostEncodeCap({ enabled = false, guests = 0 }) {
  const room = useRoomContext();
  const light = enabled && IS_IOS && guests >= 2;

  useEffect(() => {
    if (!room || !enabled || !IS_IOS) return undefined;
    let cancelled = false;
    const run = async () => {
      const s = room.localParticipant.getTrackPublication(Track.Source.Camera)?.track?.sender;
      if (!s) return;
      try {
        const params = s.getParameters(); if (!params.encodings?.length) return;
        const top = params.encodings[params.encodings.length - 1];
        if (light) { top.maxBitrate = 800_000; top.maxFramerate = 24; top.scaleResolutionDownBy = 1.34; }
        else { top.maxBitrate = 1_200_000; top.maxFramerate = 30; top.scaleResolutionDownBy = 1; }
        if (!cancelled) await s.setParameters(params);
        window.dispatchEvent(new CustomEvent("pandax:host-encode", { detail: { light } }));
      } catch { /* unsupported */ }
    };
    const t = setTimeout(run, 1200);
    return () => { cancelled = true; clearTimeout(t); };
  }, [room, enabled, light]);

  return null;
}
